import { DefaultValue } from "recoil";
import { api } from "@/comn";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { lpcoEnvs } from "@/tz/go/egaz/osci/lpco/comn"; // 시스템 공통 유틸
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { APP_CD_NO } from "@/tz/go/egaz/osci/lpco/comn/LpcoConstants";

export const BASE = {
    path: `${lpcoEnvs.base}/lpco/app`,
    api: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/app/new`,
    rprtApi: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/comn/rprt`,
    // nodes: [
    //     // TODO 라벨 처리 필요
    //     { path: "/", label: "L_ESW" },
    //     { path: "/lpco", label: "L_LPCO_APP" },
    // ],
    selectAppList: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/app/new/app-list`, // New Application List
    selectAppInfo: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/app/new/app-info`, // Application Information
    selectMdfyAppList: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/app/new/mdfy-app-list`, // Modify Application List
    selectAppAprvInfo: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/app/new/app-aprv-info`, // Application Approval Information
    selectInscAtcmList: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/app/new/insc-atcm-list`, // Application Inspection Attachment Files List
    selectBeforeAppInfo: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/app/new/bf-app-info`, // Application Information
};

export const URLS = {
    osci0201001q: `${BASE.path}/new/osci0201001q`, // Application List !== 신청서 목록 ==!
    osci0201002s: `${BASE.path}/new/osci0201002s`, // Application Detail !== 신청서 상세 ==!
    osci0201015q: `${BASE.path}/amd/osci0201015q`, // Amendment Application List !== 정정 신청서 목록 ==! ==!
    osci0201016s: `${BASE.path}/amd/osci0201016s`, // Amendment Application Detail !== 정정 신청서 상세 ==!
    osci0201003q: `${BASE.path}/new/osci0201003q`, // Application List(Vefification) !== 신청서 목록(Vefification) ==!
    osci0201004s: `${BASE.path}/new/osci0201004s`, // Application Detail(Vefification) !== 신청서 상세(Vefification) ==!
    osci0201005s: `${BASE.path}/new/osci0201005s`, // Application Detail(Vefification) !== 신청서 상세(Vefification) ==!
    osci0201009q: `${BASE.path}/new/osci0201009q`, // Application List(Inspection) !== 신청서 목록(Inspection) ==!
    osci0201010s: `${BASE.path}/new/osci0201010s`, // Application Detail(Inspection) !== 신청서 상세(Inspection) ==!
    osci0201011s: `${BASE.path}/new/osci0201011s`, // Application Detail(Inspection) !== 신청서 상세(Inspection) ==!
    osci0201012q: `${BASE.path}/new/osci0201012q`, // Application List(Approval) !== 신청서 목록(Approval) ==!
    osci0201013s: `${BASE.path}/new/osci0201013s`, // Application Detail(Approval) !== 신청서 상세(Approval) ==!
    osci0201014s: `${BASE.path}/new/osci0201014s`, // Application Detail(Approval) !== 신청서 상세(Approval) ==!
    osci0201017q: `${BASE.path}/amd/osci0201017q`, // Amendment Application List(Vefification) !== 정정 신청서 목록(Vefification) ==! ==!
    osci0201018s: `${BASE.path}/amd/osci0201018s`, // Amendment Application Detail(Vefification) !== 정정 신청서 상세(Vefification) ==!
    osci0201019s: `${BASE.path}/amd/osci0201019s`, // Amendment Application Detail(Vefification) !== 정정 신청서 상세(Vefification) ==!
    osci0201031q: `${BASE.path}/amd/osci0201031q`, // Amendment Application List(Inspection) !== 정정 신청서 목록(Inspection) ==!
    osci0201032s: `${BASE.path}/amd/osci0201032s`, // Amendment Application Detail(Inspection) !== 정정 신청서 상세(Inspection) ==!
    osci0201033s: `${BASE.path}/amd/osci0201033s`, // Amendment Application Detail(Inspection) !== 정정 신청서 상세(Inspection) ==!
    osci0201023q: `${BASE.path}/amd/osci0201023q`, // Amendment Application List(Approval) !== 정정 신청서 목록(Approval) ==! ==!
    osci0201024s: `${BASE.path}/amd/osci0201024s`, // Amendment Application Detail(Approval) !== 정정 신청서 상세(Approval) ==!
    osci0201025s: `${BASE.path}/amd/osci0201025s`, // Amendment Application Detail(Approval) !== 정정 신청서 상세(Approval) ==!
    osci0201006q: `${BASE.path}/new/osci0201006q`, // Application List(Vefification Approval) !== 신청서 목록(Vefification Approval) ==!
    osci0201007s: `${BASE.path}/new/osci0201007s`, // Application Detail(Vefification Approval) !== 신청서 상세(Vefification Approval) ==!
    osci0201008s: `${BASE.path}/new/osci0201008s`, // Application Detail(Vefification Approval) !== 신청서 상세(Vefification Approval) ==!
    osci0201020q: `${BASE.path}/amd/osci0201020q`, // Amendment Application List(Vefification Approval) !== 정정 신청서 목록(Vefification Approval) ==!
    osci0201021s: `${BASE.path}/amd/osci0201021s`, // Amendment Application Detail(Vefification Approval) !== 정정 신청서 상세(Vefification Approval) ==!
    osci0201022s: `${BASE.path}/amd/osci0201022s`, // Amendment Application Detail(Vefification Approval) !== 정정 신청서 상세(Vefification Approval) ==!
};

export const APIS = {
    // Get New Application List !== 신청서 목록 조회 ==!
    getAppList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.selectAppList}?page=${page}&size=${size}`, {
            params: data,
        });
    },
    // Get Application Information !== 신청서 정보 조회 ==!
    getAppInfo: (data: any) => {
        return api.get(`${BASE.selectAppInfo}/${data.appId}/${data.orgCd}`, {
            // params: data,
        });
    },
    // TODO 나의할일 관련 메소드 추가
    getAppInfoToAppNo: (data: any) => {
        console.log(data);
        return api.get(`${BASE.selectAppInfo}/${data.appNo}/${data.appDgr}/${data.orgCd}`, {
            // params: data,
        });
    },
    // Get Application Information(Before) !== 신청서 정보 조회(수정전) ==!
    getBeforeAppInfo: (data: any) => {
        return api.get(`${BASE.selectBeforeAppInfo}`, {
            params: data,
        });
    },
    // Change Application Assignment Confirmation Date !== 신청서 배부 확인 일시 변경 ==!
    updateReceived: (appId: any, appStatCd: any) => {
        // TODO 에러 방지 주석 추가
        return api.put(`${BASE.api}/rcve/${appId}`, { srchAppStatCd: appStatCd });
    },
    // Get LPCO Report !== LPCO 보고서 미리보기 조회==!
    getRprt: (appId: any) => {
        return api.get(`${BASE.rprtApi}/lpco/${appId}`, {
            responseType: "arraybuffer",
        });
    },
    // Get Modify Application List !== 정정 신청서 목록 조회 ==!
    getMdfyAppList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.selectMdfyAppList}?page=${page}&size=${size}`, {
            params: data,
        });
    },
    // Get Application Approval Information !== 신청서 승인 정보 조회 ==!
    getAppAprvInfo: (data: any) => {
        return api.get(`${BASE.selectAppAprvInfo}`, {
            params: data,
        });
    },
    // Save Application Approval Result !== 신청서 승인 정보 저장 ==!
    saveAppAprvRslt: (data: any) => {
        return api.post(`${BASE.api}/app-aprv-save`, {
            ...data,
        });
    },
    // Submit Application Approval Result !== 신청서 승인 정보 제출 ==!
    sbmtAppAprvRslt: (data: any) => {
        return api.post(`${BASE.api}/app-aprv-sbmt`, {
            ...data,
        });
    },
    // Request Application Approval Result !== 신청서 심사 결과 결재 요청 ==!
    rqstAprvRslt: (data: any) => {
        return api.post(`${BASE.api}/aprv-rslt-rqst`, {
            ...data,
        });
    },
    // Get Attachment File List !== 첨부파일 목록 조회 ==!
    getInscAtcmList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.selectInscAtcmList}?page=${page}&size=${size}`, {
            params: data,
        });
    },
    // Approval Result Code Exclusion List!== 승인 결과 코드 제외 목록 ==!
    getExcludeAuditRsltCdList: (
        prcsRoleTpCd: string,
        prevPrcsRoleTpCd: string,
        appCdNo?: string,
        zbsClearanceNregMarkYn?: string,
    ) => {
        const arrExcludeDefault = ["FV", "IP", "AP", "RS", "CF", "NC"];
        const excludeVerifMap: { [key: string]: string[] } = {
            VE: ["FV", "IP", "AP", "CF", "NC", "NR", "IF"],
            VA: ["VF", "IP", "AP", "CF", "NC", "NR", "IF", "CR"],
            IP: ["VF", "FV", "AP", "CF", "NC", "NR", "IF", "CR"],
            FR: ["VF", "FV", "IP", "CF", "NC", "NR", "IF", "CR"],

            EV: ["FV", "IP", "AP", "CF", "NC", "NR", "IF", "CR"],
            ES: ["VF", "IP", "AP", "CF", "NC", "NR", "IF", "CR"],
            EF: ["VF", "FV", "IP", "CF", "NC", "NR", "IF", "CR"],

            NR: ["VF", "FV", "IP", "AP", "RJ", "CF", "NC", "IF", "CR"],
        };
        let arrExcludes = [...(excludeVerifMap[prcsRoleTpCd] || arrExcludeDefault)];
        if (prevPrcsRoleTpCd == "SU") {
            arrExcludes.push("RE");
            // 이전 상태가 SU 이면 arrExcludes 에서 NR은 제거한다.
            // ZBS Clearance Permit은 예외 — 비규제 종결 권한이 VA에만 있어 VE에는 NR을 계속 닫아둔다.
            if (!(prcsRoleTpCd === "VE" && appCdNo === APP_CD_NO.ZBS_CLEARANCE)) {
                arrExcludes = arrExcludes.filter((code) => code !== "NR");
            }
        } else {
            arrExcludes.push("RS");
        }

        // ZBS Clearance Permit VA — 비규제 승인은 VA가 한다. NR을 연다.
        if (prcsRoleTpCd === "VA" && appCdNo === APP_CD_NO.ZBS_CLEARANCE) {
            arrExcludes = arrExcludes.filter((code) => code !== "NR");
            // 담당자가 비규제로 표시한 건은 FV(최종승인 → FP 진행)가 모순이라 숨긴다.
            // 동의하지 않으면 RE로 VE에 돌려보내 표시를 'N'으로 고치게 한다.
            if (zbsClearanceNregMarkYn === "Y") {
                arrExcludes.push("FV");
            }
        }

        if (appCdNo !== "OGAM0001CAP0001") {
            arrExcludes.push("CR");
        }

        // Fee payment result is recorded by system only !== 수수료납부완료는 시스템만 기록 ==!
        arrExcludes.push("PA");

        return arrExcludes;
    },
};

export const SF_APRVAPP_SRCH_COND: TFormSchema = {
    id: "form_aprvapp_srch_cond",
    schema: {
        srchAppNo: { type: "text", label: "L_APP_NO", edit: true } /* Application No !== 신청번호 ==!*/,
        srchUcrNo: { type: "text", label: "L_UCR_NO", edit: true } /* UCR No !== UCR번호 ==!*/,
        srchTin: {
            type: "text",
            label: "L_TIN",
            edit: true,
        } /* TIN !== TIN 번호 ==!*/,
        srchAppCdNo: {
            type: "select",
            label: "L_APP",
            edit: true,
        } /* Application !== Application ==!*/,
        srchSbmsDt: {
            type: "daterange",
            label: "L_SBMS_DT",
            edit: true,
            start: { name: "srchSbmsDtStart" },
            end: { name: "srchSbmsDtEnd" },
        } /* Submission Date !== 제출일자 ==!*/,
        srchAprvDt: {
            type: "daterange",
            label: "L_APRVD_DT",
            edit: true,
            start: { name: "srchAprvDtStart" },
            end: { name: "srchAprvDtEnd" },
        } /* Approval Date !== 승인일자 ==! */,
        srchAppStatCd: {
            type: "select",
            label: "L_APP_STTS",
            area: "comnCd",
            comnCd: "OSC0121",
            edit: true,
        } /* Status !== 상태 ==!*/,
        srchMdfyAppStatCd: {
            type: "select",
            label: "L_APP_STTS",
            area: "comnCd",
            comnCd: "OSC0140",
            edit: true,
        } /* Status !== 상태 ==!*/,
        srchCstmOfceCd: {
            type: "code",
            label: "L_CSTM_OFCE",
            area: "cstmCd",
            edit: true,
        } /* Customs Office !== 세관코드 ==!*/,
    },
};

export const SF_MDFYAPP_SRCH_COND: TFormSchema = {
    id: "form_mdfyapp_srch_cond",
    schema: {
        srchAppNo: { type: "text", label: "L_APP_NO", edit: true } /* Application No !== 신청번호 ==!*/,
        srchUcrNo: { type: "text", label: "L_UCR_NO", edit: true } /* UCR No !== UCR번호 ==!*/,
        srchTin: {
            type: "text",
            label: "L_TIN",
            edit: true,
        } /* TIN !== TIN 번호 ==!*/,
        srchAppCdNo: {
            type: "select",
            label: "L_APP",
            edit: true,
        } /* Application !== Application ==!*/,
        srchSbmsDt: {
            type: "daterange",
            label: "L_SBMS_DT",
            edit: true,
            start: { name: "srchSbmsDtStart" },
            end: { name: "srchSbmsDtEnd" },
        } /* Submission Date !== 제출일자 ==!*/,
        srchAprvDt: {
            type: "daterange",
            label: "L_APRVD_DT",
            edit: true,
            start: { name: "srchAprvDtStart" },
            end: { name: "srchAprvDtEnd" },
        } /* Approval Date !== 승인일자 ==! */,
        srchAppStatCd: {
            type: "select",
            label: "L_APP_STTS",
            area: "comnCd",
            comnCd: "OSC0121",
            edit: true,
        } /* Status !== 상태 ==!*/,
        srchAmdTpCd: {
            type: "select",
            label: "L_MDFY_TP",
            area: "comnCd",
            comnCd: "OSC0129",
            edit: true,
        } /* Application Amendment Type Code !== 신청서 정정 유형 코드 ==!*/,
        srchCstmOfceCd: {
            type: "code",
            label: "L_CSTM_OFCE",
            area: "cstmCd",
            edit: true,
        } /* Customs Office !== 세관코드 ==!*/,
    },
};

export const SG_APRVAPP_LST: TGridSchema = {
    id: "grid_aprvapp_lst",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: false, //체크박스 보이기 숨기기, default : false
        pagination: "out", // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: false, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        edit: false, // 그리드 편집 가능 여부 , default : false
        height: 700,
    },
    head: [
        {
            cells: [
                { header: "L_APP_NO", binding: "appNo", width: 250 },
                { header: "L_UCR_NO", binding: "ucrNo" },
            ],
            id: "appNo",
        } /* Application No / UCR No !== 신청번호 / UCR번호 ==!*/,
        {
            cells: [
                { header: "L_APP", binding: "appNm", width: "*", minWidth: 300 },
                { header: "L_CSTM_OFCE", binding: "cstmOfceNm" },
            ],
            id: "appNm",
        } /* Application / Customs Office !== 신청서명(화면표시용) / 세관코드 ==!*/,
        {
            cells: [{ header: "L_APP_TP", binding: "appTpNm", width: 180, rowspan: 2 }],
            id: "appTpNm",
        } /** Application Type Name !== 신청서_유형_코드명 ==! */,
        {
            cells: [
                { header: "L_SBMS_DT", binding: "sbmtDtm", width: 120 },
                { header: "L_APRV_DT", binding: "aprvDtm" },
            ],
            id: "sbmtDtm",
        } /* Submission Date / Approval Date !== 제출일자 / 승인일자 ==!*/,
        {
            cells: [{ header: "L_ASNMT_OFCR", binding: "asnmtOfcrNm", width: 200, rowspan: 2 }],
            id: "asnmtOfcrNm",
            show: false,
        } /* Assigned Officer !== 배정담당자 ==! */,
        {
            cells: [
                { header: "L_ASNMT_OFCR", binding: "asnmtOfcrNm", width: 250 },
                { header: "L_APRV_NO", binding: "appAprvNo" },
            ],
            id: "asnmtOfcrAprvNo",
            show: false,
        } /* Assigned Officer / Approval No !== 배정담당자 / 승인번호 ==! */,
        {
            cells: [
                { header: "L_APP_STTS", binding: "appStatNm", width: 150 },
                { header: "L_NREG_YN", binding: "nregYn" },
            ],
            id: "appStts",
        } /* Application Status / Non-Regulate Yes or not !== 신청서상태 / 비규제_여부 ==!*/,
        { cells: [{ header: "L_RCVE_1", binding: "btnRcve", width: 150, rowspan: 2 }], id: "btnRcve" },
    ],
    body: [
        {
            cells: [
                { binding: "appNo", type: "text", align: "center" },
                { binding: "ucrNo", type: "text", align: "center" },
            ],
        },
        {
            cells: [
                { binding: "appNm", type: "text", align: "left" },
                { binding: "cstmOfceNm", type: "text", align: "left" },
            ],
        },
        {
            cells: [{ binding: "appTpNm", type: "text", align: "center", rowspan: 2 }],
        },
        {
            cells: [
                { binding: "sbmtDtm", type: "date", align: "center" },
                { binding: "aprvDtm", type: "date", align: "center" },
            ],
        },
        {
            cells: [{ binding: "asnmtOfcrNm", type: "text", align: "left", rowspan: 2 }],
        },
        {
            cells: [
                { binding: "asnmtOfcrNm", type: "text", align: "left" },
                { binding: "appAprvNo", type: "text", align: "center" },
            ],
        },
        {
            cells: [
                { binding: "appStatNm", type: "text", align: "center" },
                { binding: "nregYn", type: "text", align: "center" },
            ],
        },
        {
            cells: [{ binding: "btnRcve", rowspan: 2 }],
        },
    ],
};

export const SG_MDFYAPP_LST: TGridSchema = {
    id: "grid_mdfyapp_lst",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: false, //체크박스 보이기 숨기기, default : false
        pagination: "out", // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: false, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        edit: false, // 그리드 편집 가능 여부 , default : false
        height: 700,
    },
    head: [
        {
            cells: [
                { header: "L_APP_NO", binding: "appNo", width: 250 },
                { header: "L_UCR_NO", binding: "ucrNo" },
            ],
            id: "appNo",
        } /* Application No / UCR No !== 신청번호 / UCR번호 ==!*/,
        {
            cells: [
                { header: "L_APP", binding: "appNm", width: "*", minWidth: 300 },
                { header: "L_CSTM_OFCE", binding: "cstmOfceNm" },
            ],
            id: "appNm",
        } /* Application / Customs Office !== 신청서명(화면표시용) / 세관코드 ==!*/,
        {
            cells: [
                { header: "L_APP_TP", binding: "appTpNm", width: 180 },
                { header: "L_MDFY_TP", binding: "amdTpNm" },
            ],
            id: "appTpNm",
        } /** Application Type Name / Modify Type !== 신청서_유형_코드명 / 변경구분 ==! */,
        {
            cells: [
                { header: "L_SBMS_DT", binding: "sbmtDtm", width: 120 },
                { header: "L_APRV_DT", binding: "aprvDtm" },
            ],
            id: "sbmtDtm",
        } /* Submission Date / Approval Date !== 제출일자 / 승인일자 ==!*/,
        {
            cells: [{ header: "L_ASNMT_OFCR", binding: "asnmtOfcrNm", width: 200, rowspan: 2 }],
            id: "asnmtOfcrNm",
            show: false,
        } /* Assigned Officer !== 배정담당자 ==! */,
        {
            cells: [
                { header: "L_ASNMT_OFCR", binding: "asnmtOfcrNm", width: 250 },
                { header: "L_APRV_NO", binding: "appAprvNo" },
            ],
            id: "asnmtOfcrAprvNo",
            show: false,
        } /* Assigned Officer / Approval No !== 배정담당자 / 승인번호 ==! */,
        {
            cells: [{ header: "L_APP_STTS", binding: "appStatNm", width: 150, rowspan: 2 }],
            id: "appStts",
        } /* Application Status !== 신청서상태 ==! */,
        { cells: [{ header: "L_RCVE_1", binding: "btnRcve", width: 150, rowspan: 2 }], id: "btnRcve" },
    ],
    body: [
        {
            cells: [
                { binding: "appNo", type: "text", align: "center" },
                { binding: "ucrNo", type: "text", align: "center" },
            ],
        },
        {
            cells: [
                { binding: "appNm", type: "text", align: "left" },
                { binding: "cstmOfceNm", type: "text", align: "left" },
            ],
        },
        {
            cells: [
                { binding: "appTpNm", type: "text", align: "center" },
                { binding: "amdTpNm", type: "text", align: "center" },
            ],
        },
        {
            cells: [
                { binding: "sbmtDtm", type: "date", align: "center" },
                { binding: "aprvDtm", type: "date", align: "center" },
            ],
        },
        {
            cells: [{ binding: "asnmtOfcrNm", type: "text", align: "left", rowspan: 2 }],
        },
        {
            cells: [
                { binding: "asnmtOfcrNm", type: "text", align: "left" },
                { binding: "appAprvNo", type: "text", align: "center" },
            ],
        },
        {
            cells: [{ binding: "appStatNm", type: "text", align: "center", rowspan: 2 }],
        },
        {
            cells: [{ binding: "btnRcve", rowspan: 2 }],
        },
    ],
};

export const SF_APRVAPP_DTL: TFormSchema = {
    id: "form_aprvapp_dtl",
    schema: {
        appId: { type: "text", edit: false } /* Application Universally Unique Identifier !== 신청서_UUID ==!*/,
        amdTpCd: { type: "text", edit: false } /* Amenment Type Code !== 정정유형코드 ==!*/,
        appNo: { type: "text", label: "L_APP_NO", edit: false } /* Application No !== 신청번호 ==!*/,
        ucrNo: { type: "text", label: "L_UCR_NO", edit: false } /* UCR No !== UCR번호 ==!*/,
        orgCd: {
            type: "text",
            edit: false,
        } /* OGA !== OGA ==!*/,
        orgNm: {
            type: "text",
            label: "L_OGA",
            edit: false,
        } /* OGA !== OGA명(화면표시용) ==!*/,
        appTpCd: {
            type: "text",
            edit: false,
        } /** Application Type Code !== 신청서_유형_코드 ==! */,
        appTpNm: {
            type: "text",
            label: "L_APP_TP",
            edit: false,
        } /** Application Type Name !== 신청서_유형_코드명 ==! */,
        appNm: { type: "text", label: "L_APP", edit: false } /* Application !== 신청서명(화면표시용) ==!*/,
        sbmtDtm: {
            type: "date",
            label: "L_SBMS_DT",
            edit: false,
        } /* Submission Date !== 제출일자 ==!*/,
        aprvDtm: {
            type: "date",
            label: "L_APRV_DT",
            edit: false,
        } /* Approval Date !== 승인일자 ==!*/,
        appAprvNo: { type: "text", label: "L_APRV_NO", edit: false } /* Approval No !== 승인번호 ==!*/,
        appStatCd: {
            type: "text",
            edit: false,
        } /* Status !== 상태 ==!*/,
        appStatNm: {
            type: "text",
            label: "L_STTS",
            edit: false,
        } /* Status !== 상태 ==!*/,
        appXpirDt: {
            type: "date",
            label: "L_VLD_DT",
            edit: false,
        } /* Valid Date !== 유효일자 ==!*/,
        mstrAprvNo: { type: "text", label: "L_MSTR_NO", edit: false } /* Master No. !== 마스터번호 ==!*/,
        amdRsn: { type: "textarea", required: true, edit: false } /* Reason to Amend !== 수정이유 ==!*/,
        nregYn: { type: "text", label: "L_NREG_YN", edit: false } /* Non-Regulated !== 비규제_여부 ==! */,
        tansadNo: {
            label: "L_TANSAD_NO",
            controlSize: 2,
            edit: false,
        } /* TANSAD No !== TANSAD 번호 ==!*/,
        cstmOfceCd: {
            type: "text",
            controlSize: 1,
            only: "control",
            edit: false,
        } /* Customs Office Code !== 세관 사무소 코드 ==! */,
        tansadYy: {
            type: "text",
            controlSize: 1,
            only: "control",
            edit: false,
        } /* TANSAD Year !== TANSAD 년도 ==! */,
        tansadSrno: {
            type: "text",
            controlSize: 1,
            only: "control",
            edit: false,
        } /* TANSAD Serial Number !== TANSAD 일련번호 ==! */,
        audtOpinCn: {
            type: "textarea",
            label: "L_AUDT_OPIN_CN",
            edit: false,
        } /* Audit Opinion Contents !== 감사의견 내용 ==! */,
    },
};

export const SF_APP_DTL_VRFN_INFO: TFormSchema = {
    id: "form_app_dtl_vrfn_info",
    schema: {
        appNm: { type: "text", label: "L_APP", edit: false } /* Application !== 신청서 ==!*/,
        appCdNo: { type: "text", edit: false } /* Application Code No !== 신청서_코드번호 ==!*/,
        appNo: {
            type: "text",
            label: "L_APP_NO",
            edit: false,
        } /* Application No !== 신청번호 ==!*/,
        ucrNo: { type: "text", label: "L_UCR_NO", edit: false } /* UCR No !== UCR번호 ==!*/,
        sbmtDtm: {
            type: "date",
            label: "L_SBMS_DT",
            edit: false,
        } /* Submission Date !== 제출일자 ==!*/,
        aplcNm: {
            type: "text",
            label: "L_APLC_NM",
            edit: false,
        } /* Applicant Name. !== 신청자명 ==!*/,
        vrfnOfcr: {
            type: "text",
            label: "L_VRFN_OFCR",
            edit: false,
        } /* Verification Officer !== 심사담당자 ==!*/,
        vrfnDt: {
            type: "text",
            label: "L_VRFN_DT_1",
            edit: false,
        } /* Verification Date !== 심사일자 ==!*/,
        vrfnAprvOfcr: {
            type: "text",
            label: "L_VRFN_APRV_OFCR",
            edit: false,
        } /* Verification Approval Officer !== 심사승인담당자 ==!*/,
        vrfnAprvDt: {
            type: "text",
            label: "L_VRFN_APRV_DT",
            edit: false,
        } /* Verification Approval Date !== 심사승인일자 ==!*/,
    },
};

export const SF_APP_RGST_VRFN_RSLT: TFormSchema = {
    id: "form_app_rgst_vrfn_vrfn",
    schema: {
        asnmtId: {
            type: "text",
            edit: false,
        } /* Assignment Universally Unique Identifier !== 배정_UUID ==!*/,
        reffId: {
            type: "text",
            edit: false,
        } /* Reference Universally Unique Identifier !== 참고_UUID ==!*/,
        prcssStatCd: {
            type: "select",
            label: "L_VRFN_RSLT",
            area: "comnCd",
            comnCd: "OSC0131",
            required: true,
            edit: true,
        } /* Verification Result !== 심사결과 ==!*/,
        prcssRsnCn: {
            type: "textarea",
            label: "L_VRFN_RMRK",
            required: true,
            edit: true,
        } /* Verification Reason !== 심사결과이유 ==!*/,
        rmrk: { type: "textarea", label: "L_RMRK", edit: true } /* Remark !== Remark ==!*/,
        exmpnTaxTpCd: {
            type: "checkbox",
            label: "L_EXMPN_TAX_TP",
            area: "comnCd",
            comnCd: "OSC0142",
            required: true,
            edit: true,
        } /* Verification Result !== 심사결과 ==!*/,
        /* 2026-05-06 KNH: Inspection Officer Assignment !== 검사담당자 배정 추가 ==! */
        asnmtOfcrYn: {
            type: "text",
            edit: false,
        } /* Assignment Officer !== 담당자_배정_여부 ==!*/,
        asnmtOfcrNm: {
            type: "text",
            label: "L_INSC_OFCR",
            edit: true,
            disabled: true,
            required: true,
        } /* Assignment Officer Name !== 담당자_이름 ==!*/,
        asnmtOfcrId: {
            type: "text",
            edit: false,
        } /* Assignment Officer ID !== 담당자_ID ==!*/,
    },
};

export const SF_APP_DTL_INSC_INFO: TFormSchema = {
    id: "form_app_dtl_insc_info",
    schema: {
        appNm: { type: "text", label: "L_APP", edit: false } /* Application !== 신청서 ==!*/,
        appNo: {
            type: "text",
            label: "L_APP_NO",
            edit: false,
        } /* Application No !== 신청번호 ==!*/,
        ucrNo: { type: "text", label: "L_UCR_NO", edit: false } /* UCR No !== UCR번호 ==!*/,
        sbmtDtm: {
            type: "date",
            label: "L_SBMS_DT",
            edit: false,
        } /* Submission Date !== 제출일자 ==!*/,
        aplcNm: {
            type: "text",
            label: "L_APLC_NM",
            edit: false,
        } /* Applicant Name. !== 신청자명 ==!*/,
        inscOfcr: {
            type: "text",
            label: "L_INSC_OFCR",
            edit: false,
        } /* Inspection Officer !== 검사담당자 ==!*/,
        inscDt: {
            type: "text",
            label: "L_INSC_DT",
            edit: false,
        } /* Verification Date !== 심사일자 ==!*/,
        inscAprvOfcr: {
            type: "text",
            label: "L_INSC_APRV_OFCR",
            edit: false,
        } /* Inspection Approval Officer !== 검사승인담당자 ==!*/,
        inscAprvDt: {
            type: "text",
            label: "L_INSC_APRV_DT",
            edit: false,
        } /* Inspection Approval Date !== 검사승인일자 ==!*/,
    },
};

export const SF_APP_RGST_INSC_RSLT: TFormSchema = {
    id: "form_app_rgst_insc_rslt",
    schema: {
        asnmtId: {
            type: "text",
            edit: false,
        } /* Assignment Universally Unique Identifier !== 배정_UUID ==!*/,
        reffId: {
            type: "text",
            edit: false,
        } /* Reference Universally Unique Identifier !== 참고_UUID ==!*/,
        prcssStatCd: {
            type: "select",
            label: "L_INSC_RSLT",
            area: "comnCd",
            comnCd: "OSC0131",
            required: true,
            edit: true,
        } /* Verification Result !== 심사결과 ==!*/,
        prcssRsnCn: {
            type: "textarea",
            label: "L_INSC_RMRK",
            required: true,
            edit: true,
        } /* Verification Reason !== 심사결과이유 ==!*/,
        rmrk: { type: "textarea", label: "L_RMRK", edit: true } /* Remark !== Remark ==!*/,
    },
};

export const SG_APP_RGST_INSC_ATCM: TGridSchema = {
    id: "form_app_rgst_insc_atcm",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: true, //체크박스 보이기 숨기기, default : false
        pagination: "in", // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        edit: true, // 그리드 편집 가능 여부 , default : false
        height: 300,
    },
    head: [
        { cells: [{ header: "L_DOC_TP", binding: "atcmTpCd", width: 300 }] } /* Document Type !== 문서타입 ==!*/,
        { cells: [{ header: "L_ATCD_FILE", binding: "atchFile", width: "*" }] } /* Attached File !== 첨부파일 ==!*/,
    ],
    body: [
        {
            cells: [
                {
                    binding: "atcmTpCd",
                    type: "code",
                    area: "comnCd",
                    comnCd: "OSC0025",
                    popupSize: "lg",
                    required: true,
                },
            ],
        },
        {
            cells: [
                {
                    binding: "atchFile",
                    type: "file",
                    align: "left",
                    bsopClsfCd: "OSC",
                    mode: "edit",
                    required: true,
                },
            ],
        },
    ],
};

export const SF_APP_DTL_APRV_INFO: TFormSchema = {
    id: "form_app_dtl_aprv_info",
    schema: {
        appNm: { type: "text", label: "L_APP", edit: false } /* Application !== 신청서 ==!*/,
        appNo: {
            type: "text",
            label: "L_APP_NO",
            edit: false,
        } /* Application No !== 신청번호 ==!*/,
        ucrNo: { type: "text", label: "L_UCR_NO", edit: false } /* UCR No !== UCR번호 ==!*/,
        sbmtDtm: {
            type: "date",
            label: "L_SBMS_DT",
            edit: false,
        } /* Submission Date !== 제출일자 ==!*/,
        aplcNm: {
            type: "text",
            label: "L_APLC_NM",
            edit: false,
        } /* Applicant Name. !== 신청자명 ==!*/,
        vrfnOfcr: {
            type: "text",
            label: "L_VRFN_OFCR",
            edit: false,
        } /* Verification Officer !== 심사담당자 ==!*/,
        vrfnDt: {
            type: "text",
            label: "L_VRFN_DT_1",
            edit: false,
        } /* Verification Date !== 심사일자 ==!*/,
        vrfnAprvOfcr: {
            type: "text",
            label: "L_VRFN_APRV_OFCR",
            edit: false,
        } /* Verification Approval Officer !== 심사승인담당자 ==!*/,
        vrfnAprvDt: {
            type: "text",
            label: "L_VRFN_APRV_DT",
            edit: false,
        } /* Verification Approval Date !== 심사승인일자 ==!*/,
    },
};

export const SF_APP_RGST_APRV_RSLT: TFormSchema = {
    id: "form_app_rgst_aprv_vrfn",
    schema: {
        asnmtId: {
            type: "text",
            edit: false,
        } /* Assignment Universally Unique Identifier !== 배정_UUID ==!*/,
        reffId: {
            type: "text",
            edit: false,
        } /* Reference Universally Unique Identifier !== 참고_UUID ==!*/,
        prcssStatCd: {
            type: "select",
            label: "L_APRV_RSLT",
            area: "comnCd",
            comnCd: "OSC0131",
            required: true,
            edit: true,
        } /* Verification Result !== 심사결과 ==!*/,
        prcssRsnCn: {
            type: "textarea",
            label: "L_APRV_RMRK",
            required: true,
            edit: true,
        } /* Verification Reason !== 심사결과이유 ==!*/,
        rmrk: { type: "textarea", label: "L_RMRK", edit: true } /* Remark !== Remark ==!*/,
        exmpnTaxTpCd: {
            type: "checkbox",
            label: "L_EXMPN_TAX_TP",
            area: "comnCd",
            comnCd: "OSC0142",
            required: true,
            edit: true,
        } /* Verification Result !== 심사결과 ==!*/,
    },
};

export const SG_APP_DTL_INSC_ATCM: TGridSchema = {
    id: "form_app_dtl_insc_atcm",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: false, //체크박스 보이기 숨기기, default : false
        pagination: "in", // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        edit: false, // 그리드 편집 가능 여부 , default : false
        height: 300,
    },
    head: [
        { cells: [{ header: "L_DOC_TP", binding: "atcmTpNm", width: "*" }] } /* Document Type !== 문서유형 ==!*/,
        { cells: [{ header: "L_ATCD_FILE", binding: "atchFile", width: "*" }] } /* Attached File !== 첨부파일 ==!*/,
    ],
    body: [
        {
            cells: [{ binding: "atcmTpNm", type: "text", align: "left", edit: false }],
        },
        {
            cells: [
                {
                    binding: "atchFile",
                    type: "file",
                    align: "left",
                    bsopClsfCd: "OSC",
                    mode: "view",
                    required: true,
                },
            ],
        },
    ],
};

export const SF_APP_RGST_VRFN_APRV_RSLT: TFormSchema = {
    id: "form_app_rgst_vrfn_aprv_rslt",
    schema: {
        asnmtId: {
            type: "text",
            edit: false,
        } /* Assignment Universally Unique Identifier !== 배정_UUID ==!*/,
        reffId: {
            type: "text",
            edit: false,
        } /* Reference Universally Unique Identifier !== 참고_UUID ==!*/,
        prcssStatCd: {
            type: "select",
            label: "L_VRFN_APRV_RSLT",
            area: "comnCd",
            comnCd: "OSC0131",
            required: true,
            edit: true,
        } /* Verification Result !== 심사결과 ==!*/,
        prcssRsnCn: {
            type: "textarea",
            label: "L_VRFN_APRV_RMRK",
            required: true,
            edit: true,
        } /* Verification Reason !== 심사결과이유 ==!*/,
        exmpnTaxTpCd: {
            type: "checkbox",
            label: "L_EXMPN_TAX_TP",
            area: "comnCd",
            comnCd: "OSC0142",
            required: true,
            edit: true,
        } /* Verification Result !== 심사결과 ==!*/,
        rmrk: { type: "textarea", label: "L_RMRK", edit: true } /* Remark !== Remark ==!*/,
    },
};
